<template>
	<div class="view changePass-view">
		<HeaderBar />
		<div class="form-wrap">
			<div class="field-item">
				<input class="field-ipt"
					   placeholder="手机号码"
					   v-model="mobile" />
				<div class="text--error"></div>
				<van-button class="captcha-btn"
							plain
							type="primary"
							size="mini"
							@click="getCaptcha"
							:disabled="countingDown !== 0">{{
					`${countingDown !== 0 ? `重新发送${countingDown}秒` : '发送验证码'}`
					}}</van-button>
			</div>
			<div class="field-item">
				<input class="field-ipt"
					   placeholder="短信验证"
					   v-model="code" />

				<div class="text--error"></div>
			</div>
			<div class="field-item">
				<input class="field-ipt"
					   placeholder="新密码"
					   type="password"
					   v-model="npwd" />
				<div class="text--error"></div>
			</div>
			<div class="field-item">
				<input class="field-ipt"
					   placeholder="确认密码"
					   type="password"
					   v-model="confirmPwd" />
				<div class="text--error"></div>
			</div>
		</div>
		<van-button type="primary"
					class="submit-btn"
					@click="onSubmitClick">确定</van-button>
	</div>

</template>
<script>
import { Toast } from 'mint-ui'

import { Button } from 'vant'
import apiUtil from '../../utils/apiUtil'
import { isPhoneNum } from '../../utils/regexUtil'
import apiConst from '../../consts/apiConst'
import HeaderBar from '../../components/HeaderBar'

let timer = null

export default {
	name: 'changePass',
	components: {
		HeaderBar,
		'van-button': Button
	},
	data() {
		return {
			mobile: '',
			code: '',
			npwd: '',
			confirmPwd: '',
			countingDown: 0
		}
	},
	methods: {
		regMobile(){
			if(!this.mobile){
				Toast({
					message: '手机号码不能为空',
					duration: 1000
				})
				return false;
			}
			if (!isPhoneNum(this.mobile)) {
				Toast({
					message: '请输入正确的手机号',
					duration: 1000
				})
				return false;
			}
			return true;
		},
		validate() {
			if (!this.code || !this.npwd || !this.confirmPwd) {
				Toast({
					message: '请将信息填写完整',
					duration: 1000
				})
				return false;
			}
			if (!isPhoneNum(this.mobile)) {
				Toast({
					message: '请输入正确的手机号',
					duration: 1000
				})
				return false;
			}

			if (this.npwd !== this.confirmPwd) {
				Toast({
					message: '两次输入的密码不一致',
					duration: 1000
				})
				return false;
			}
			return true;
		},

		async getCaptcha() {
			if (!this.regMobile()) {
				return;
			}
			const res = await apiUtil.post(apiConst.getCaptcha, {
				type: 3,
				mobile: this.mobile
			})
			if (res.success) {
				Toast({
					message: '发送成功',
					duration: 1000,
					background: '#8FC31E'
				})
				this.countingDown = 60
				timer = setInterval(() => {
					this.countingDown--
					if (this.countingDown === 0) {
						clearInterval(timer)
					}
				}, 1000)
			}
		},

		async onSubmitClick() {
			if (!this.validate()) {
				return;
			}
			const res = await apiUtil.post(apiConst.submitPassword, {
				mobile: this.mobile,
				code: this.code,
				npwd: this.npwd
			})
			if (res.success) {
				Toast({
					message: '密码已修改，请重新登录',
					duration: 1000,
					background: '#8FC31E'
				})
				this.$router.push('/login')
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.changePass-view {
	padding-left: 48px;
	padding-right: 48px;

	.form-wrap {
		padding: 30px 0;

		.field-item {
			position: relative;
			padding: 20px 8px;
			border-bottom: 1PX solid #ccc;

			.field-ipt {
				padding-top: 20px;
				height: 100%;
				font-size: 32px;

				&::-webkit-input-placeholder {
					color: #999;
					font-size: 32px;
				}
			}

			.captcha-btn {
				position: absolute;
				height: 48px;
				line-height: 46px;
				right: 8px;
				bottom: 12px;
				font-size: 28px;
				padding: 0 10px;
			}
		}

		.field-item--cbx {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	.submit-btn {
		margin-top: 64px;
		width: 100%;
		height: 88px;
		line-height: 88px;
		background-color: #8FC31E;
		border-radius: 4px;
		color: #fff;
		text-align: center;
	}
}
</style>
